<template>
<div>
<ContentHeader title="Yeni Akış Sorusu"  url="FlowVerification" :show_button="true"  icon="arrow-left" buttontype="danger" label="Geri"></ContentHeader>
<template v-if="loading">
<FrameOverlay></FrameOverlay>
</template>

<template v-if="!loading">
<form @submit.prevent="submitForm" class="mt-4">
<div class="grid">
</div>
</form>
</template>



</div>	
</template>

<script>
export default {

  name: 'FlowNewQuestion',

  data () {
    return {
    	loading:true, 
    	item:null,	
    	fields:[
	      {
	        title:"İsim",
	        key:"name",
	        type:"text",
	        value:null,
	        min_length:2,
	        max_length:50,
	        is_required:true,
	        has_error:false,
	        error_message:null,
	        show:true,
	      },
	      {
	        title:"Tür",
	        key:"type",
	        type:"select",
	        value:[],
	        is_required:true,
	        has_error:false,
	        error_message:null,
	        show:true,
	        options:[
	        {
	          name:"Metin",
	          id:"string"
	        },
	        {
	          name:"Sayı",
	          id:"number"
	        },
	        {
	          name:"Açık/kapalı",
	          id:"switch"
	        },
	        {
	          name:"Opsiyonlu",
	          id:"select"
	        }
	        ],
	      },
	      {
	        title:"Varsayılan Değer (Text)",
	        key:"default_text",
	        type:"text",
	        value:null,
	        min_length:2,
	        max_length:50,
	        is_required:false,
	        has_error:false,
	        error_message:null,
	        show:true,
	      },
	      {
	        title:"Varsayılan Değer (Sayı)",
	        key:"default_number",
	        type:"number",
	        value:null,
	        min_length:2,
	        max_length:50,
	        is_required:false,
	        has_error:false,
	        error_message:null,
	        show:true,
	      },
	      {
	        title:"Opsiyonlar",
	        key:"options",
	        type:"chips",
	        value:[],
	        min_length:0,
	        max_length:50000000,
	        is_required:false,
	        has_error:false,
	        error_message:null,
	        show:true,
	      },
	      {
	        title:"Varsayılan Durum",
	        key:"default_switch",
	        type:"select",
	        value:[],
	        is_required:false,
	        has_error:false,
	        error_message:null,
	        show:true,
	        options:[],
	      },

      ]

    }
  }
};
</script>

<style lang="css" scoped>
</style>